import { Container } from "react-bootstrap";
import { Col, Row } from "react-bootstrap";
import BackArrow from "../../components/backArrow";
import { useState, useEffect } from "react";
import Card from "react-bootstrap/Card";
import { images } from "../../constants";
import { useNavigate } from "react-router-dom";
import { Measurementunit, currencies } from "../../constants/jsonConstant";
import ClearIcon from "@mui/icons-material/Clear";
import { useSelector } from "react-redux";
import Loader from "../../components/Loader";
import { SuccessNotify, FailedNotify } from "../../constants/tostify";
import { publishImage } from "../../helpers/imageupload";
import { useDropzone } from "react-dropzone";
import { getAsset } from "../../helpers/helper";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import {
  useCreateShopItemMutation,
  useLazyGetShopConsumerCategoriesQuery,
  useLazyGetShopCategoriesQuery,
  useGetWorldCitiesQuery
} from "../../features/shop/shopApiSlice";

const PostSingleAdd = () => {
  const navigate = useNavigate();
  const [isloading, setIsloading] = useState(false);
  const [shopCategory, setShopCategory] = useState();
  const [shopCategorytwo, setShopCategorytwo] = useState();
  const [displayimg, setDisplayimg] = useState();
  const [isUploading, setIsUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const { name } = useSelector((state) => state.user);
  const [data, setData] = useState({
    categoryid: "",
    subCategoryid: "",
  });

  const Handledata = (e) => {
    setData((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value.split("."),
    }));
  };

  const categoryName = data?.categoryid[1];
  const categoryidone = data.categoryid[0];
  const subcategoryName = data?.subCategoryid[1];
  const subcategorytwo = data.subCategoryid[0];

  const onDrop = async (acceptedFiles) => {
    try {
      setIsUploading(true);
      setUploadProgress(0);

      const abc = await publishImage(acceptedFiles, (percent) => {
        setUploadProgress(percent);
      });
      setUserData((userData) => ({
        ...userData,
        images: abc,
      }));
      setDisplayimg(abc);
    } catch (error) {
      FailedNotify("Failed! Try Again");
    } finally {
      setIsUploading(false);
      setUploadProgress(0);
    }
  };

  const { getRootProps, getInputProps } = useDropzone({
    accept: "image/*",
    onDrop,
  });

  const [userData, setUserData] = useState({
    userid: name._id,
    itemname: "",
    isSingleItem: true,
    isScrapeItem: false,
    category: "",
    categoryid: "",
    subCategory: "",
    subCategoryid: "",
    price: "",
    country: "",
    city: "",
    state: "",
    quantity: "",
    description: "",
    unitOfMeasurement: "",
    currency: "",
    images: [""],
    status: true,
  });

  useEffect(() => {
    setUserData((userData) => ({
      ...userData,
      category: categoryName,
      categoryid: categoryidone,
      subCategory: subcategoryName,
      subCategoryid: subcategorytwo,
    }));

  }, [categoryName, categoryidone, subcategoryName, subcategorytwo]);

  const [getShopConsumerCategories] = useLazyGetShopConsumerCategoriesQuery();
  const [getShopCategories] = useLazyGetShopCategoriesQuery();
  const [createShopItem] = useCreateShopItemMutation();

  const FirstCategory = async (e) => {
    e.preventDefault();
    try {
      const response = await getShopConsumerCategories({ type: 'singleItem', parentCategory: '' }).unwrap();
      if (response?.success) {
        setShopCategory(response?.data?.Category);
      }
    } catch (error) {
      console.log("servicesCategories", error);
    }
  };

  const InputChange = (e) => {
    setUserData((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
  };

  const Mydata = async (e) => {
    e.preventDefault();
    try {
      const response = await getShopCategories({ type: 'singleItem', parentCategory: categoryName }).unwrap();
      if (response?.success) {
        setShopCategorytwo(response?.data?.Category);
      }
    } catch (error) {
      console.log("servicesCategories", error);
    }
  };

  const userDatahandler = async (e) => {
    e.preventDefault();
    setIsloading(true);
    try {
      const response = await createShopItem(userData).unwrap();
      if (response?.success) {
        setIsloading(false);
        setTimeout(() => {
          SuccessNotify("Add Post Successfully");
        }, 1000);
        navigate(`/singleadd-show`);
      }
    } catch (error) {
      setIsloading(false);
      FailedNotify("Failed To Post Try Again!");
    }
  };

  const removeImage = (index) => {
    const updatedImages = [...displayimg];
    updatedImages.splice(index, 1);
    setDisplayimg(updatedImages);
  };

  const [selectedCountry, setSelectedCountry] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedstateone, setSelectedstateone] = useState("");
  const [searchTermone, setSearchTermone] = useState("");
  const [selectedcity, setSelectedcity] = useState("");
  const [searchTermtwo, setSearchTermtwo] = useState("");
  const [hidefield, setHidefield] = useState(1);
  const [hidestate, setHidestate] = useState(1);
  const [hidecity, setHidecity] = useState(1);
  const [countrydata, SetCountrydata] = useState([]);
  const [getState, setState] = useState([]);
  const [getcity, setGetcity] = useState([]);

  const handleCountryChange = (event) => {
    const { value } = event.target;
    setSelectedCountry(value);
  };

  const handleSearchChangestate = (event) => {
    setSearchTermone(event.target.value);
  };

  const handleSearchChangecity = (event) => {
    setSearchTermtwo(event.target.value);
  };

  const handleCountryChangestate = (event) => {
    const { value } = event.target;
    setSelectedstateone(value);
  };

  const handleCountryChangecity = (event) => {
    const { value } = event.target;
    setSelectedcity(value);
  };

  const { data: citiesData } = useGetWorldCitiesQuery();

  useEffect(() => {
    if (citiesData) {
      SetCountrydata(citiesData);
    }
  }, [citiesData]);

  const country = [...new Set(countrydata.map((item) => item.country))];
  country.sort();

  const handleCountry = (e) => {
    let states = countrydata.filter((state) => state.country === e.target.value);
    states = [...new Set(states.map((item) => item.subcountry))];
    states.sort();
    setState(states);
  };

  const handleState = (e) => {
    let cities = countrydata.filter((city) => city.subcountry === e.target.value);
    setGetcity(cities);
  };

  if (isloading) {
    return <Loader heightsetting="screenHeight" />;
  }

  const validationSchema = Yup.object({
    description: Yup.string().required("description is required*"),
    state: Yup.string().required("state is required*"),
  });

  return (
    <>
      <Container>
        <Row>
          <div className="screenHeight d-flex justify-content-center align-items-center">
            <Col lg={10} md={12} sm={12} xs={12} className="Form-Shadow">
              <Row>
                <Col className="">
                  <div className="arrowback ps-3">
                    <BackArrow
                      back="/SellingSide"
                      black="black"
                      mystyle="ps-4 p-1"
                    />
                  </div>
                </Col>
              </Row>
              <Formik
                initialValues={{
                  description: "",
                  state: "",
                  itemname: "",
                  brandname: "",
                  price: "",
                  quantity: "",
                  categoryid: "",
                  subCategoryid: "",
                  country: "",
                  city: "",
                  unitOfMeasurement: "",
                  currency: "",
                }}
                validateOnBlur={false}
                validationSchema={validationSchema}
                onSubmit={(values) => { }}
              >
                {({
                  handleChange,
                  handleBlur,
                  handleSubmit,
                  errors,
                  touched,
                  isValid,
                  dirty,
                }) => (
                  <Form

                    onSubmit={(e) => {
                      userDatahandler(e);
                      handleSubmit(e);
                    }}
                  >
                    {/* Hidden input to trick autofill */}
                    <input
                      type="text"
                      style={{ display: "none" }}
                      autoComplete="off"
                    />
                    <div className="p-4">
                      <Row className="pt-2 pb-2 px-3">
                        <Col md={3} lg={3} xl={3}>
                          <label className="custm-lble">Item Name</label>
                          <input
                            placeholder="Item Name"
                            name="itemname" // Non-standard name
                            className="input-style form-control-seller place form-control"
                            onChange={(e) => {
                              InputChange(e);
                              handleChange(e);
                            }}
                            autoComplete="off"


                          />
                        </Col>
                        <Col md={3} lg={3} xl={3}>
                          <label className="custm-lble">Brand Name</label>
                          <input
                            placeholder="Optional"
                            name="brandname" // Non-standard name
                            className="input-style form-control-seller place form-control"
                            onChange={(e) => {
                              InputChange(e);
                              handleChange(e);
                            }}
                            autoComplete="off"


                          />
                        </Col>
                        <Col md={3} lg={3} xl={3}>
                          <label className="custm-lble">Select Category</label>
                          <div className="">
                            <select
                              onChange={(e) => {
                                Handledata(e);
                                handleChange(e);
                              }}
                              onClick={(e) => FirstCategory(e)}
                              className="input-style form-control-seller form-select"
                              aria-label="Default select example"
                              name="categoryid" // Non-standard name
                              autoComplete="off"
                            >
                              <option>Select Category</option>
                              {shopCategory?.map((e) => (
                                <option key={e?._id} value={`${e?._id}.${e?.name}`}>
                                  {e?.name}
                                </option>
                              ))}
                            </select>
                          </div>
                          {errors.categoryid && touched.categoryid ? (
                            <div>
                              <p className="error_text_color">{errors.categoryid}</p>
                            </div>
                          ) : null}
                        </Col>
                        <Col md={3} lg={3} xl={3}>
                          <label className="custm-lble">Select Sub-Category</label>
                          <div className="">
                            <select
                              className="input-style form-control-seller form-select"
                              aria-label="Default select example"
                              name="subCategoryid" // Non-standard name
                              onChange={(e) => {
                                Handledata(e);
                                handleChange(e);
                              }}
                              onClick={(e) => Mydata(e)}
                              autoComplete="off"
                            >
                              <option>Select Sub-Category</option>
                              {shopCategorytwo?.map((e) => (
                                <option key={e?._id} value={`${e?._id}.${e?.name}`}>
                                  {e?.name}
                                </option>
                              ))}
                            </select>
                          </div>
                          {errors.subCategoryid && touched.subCategoryid ? (
                            <div>
                              <p className="error_text_color">{errors.subCategoryid}</p>
                            </div>
                          ) : null}
                        </Col>
                      </Row>
                      <Row className="pt-2 pb-2 px-3">
                        <Col md={3} lg={3} xl={3}>
                          <label className="custm-lble">Price</label>
                          <input
                            onChange={(e) => {
                              InputChange(e);
                              handleChange(e);
                            }}
                            placeholder="Price"
                            name="price" // Non-standard name
                            className="input-style form-control-seller place form-control"
                            type="number"
                            autoComplete="off"


                          />
                          {errors.price && touched.price ? (
                            <div>
                              <p className="error_text_color">{errors.price}</p>
                            </div>
                          ) : null}
                        </Col>
                        <Col md={3} lg={3} xl={3}>
                          <label className="custm-lble">Total Quantity</label>
                          <input
                            onChange={(e) => {
                              InputChange(e);
                              handleChange(e);
                            }}
                            placeholder="Quantity"
                            name="quantity" // Non-standard name
                            className="input-style form-control-seller place form-control"
                            type="number"
                            autoComplete="off"


                          />
                          {errors.quantity && touched.quantity ? (
                            <div>
                              <p className="error_text_color">{errors.quantity}</p>
                            </div>
                          ) : null}
                        </Col>
                        <div className="col-md-3">
                          <label className="form-label labelSize mb-0">Country*</label>
                          <div className="blood-type input-style p-1 form-control-seller">
                            {/* <div className="d-flex">
                              <div className="w-100">
                                <input
                                  type="search"
                                  value={searchTerm}
                                  onChange={handleSearchChange}
                                  placeholder="Search country here...."
                                  className="w-100 search-input"
                                  onClick={() => setHidefield(0)}
                                  autoComplete="off"
                                />
                              </div>
                              <div>
                                <span>
                                  <SearchIcon className="search-icon-fs" />
                                </span>
                              </div>
                            </div> */}
                            <select
                              onClick={() => setHidefield(1)}
                              value={selectedCountry}
                              onChange={(e) => {
                                InputChange(e);
                                handleCountryChange(e);
                                handleCountry(e);
                                handleChange(e);
                              }}
                              className="b-radius selectSize w-100"
                              name="country" // Non-standard name
                              autoComplete="off"
                            >
                              {hidefield && <option>Select country</option>}
                              {country
                                .filter((country) =>
                                  country.toLowerCase().includes(searchTerm.toLowerCase())
                                )
                                .map((country, index) => (
                                  <option key={country} value={country}>
                                    {country}
                                  </option>
                                ))}
                            </select>
                          </div>
                          {errors.country && touched.country ? (
                            <div>
                              <p className="error_text_color">{errors.country}</p>
                            </div>
                          ) : null}
                        </div>
                        <div className="col-md-3">
                          <label className="form-label labelSize mb-0">State*</label>
                          <div className="blood-type input-style form-control-seller p-1">
                            {/* <div className="d-flex">
                              <div className="w-100">
                                <input
                                  type="search"
                                  value={searchTermone}
                                  onChange={handleSearchChangestate}
                                  placeholder="Search state here...."
                                  className="w-100 search-input"
                                  onClick={() => setHidestate(0)}
                                  autoComplete="off"
                                />
                              </div>
                              <div>
                                <span>
                                  <SearchIcon className="search-icon-fs" />
                                </span>
                              </div>
                            </div> */}
                            <select
                              onClick={() => setHidestate(1)}
                              className="b-radius selectSize w-100"
                              value={selectedstateone}
                              aria-label="Default select example"
                              name="state" // Non-standard name
                              onChange={(e) => {
                                InputChange(e);
                                handleState(e);
                                handleCountryChangestate(e);
                                handleChange(e);
                              }}
                              autoComplete="off"
                            >
                              {hidestate && <option>Select state</option>}
                              {getState
                                .filter((state) =>
                                  state.toLowerCase().includes(searchTermone.toLowerCase())
                                )
                                .map((state) => (
                                  <option key={state} value={state}>
                                    {state}
                                  </option>
                                ))}
                            </select>
                          </div>
                          {errors.state && touched.state ? (
                            <div>
                              <p className="error_text_color">{errors.state}</p>
                            </div>
                          ) : null}
                        </div>
                      </Row>
                      <Row className="pt-2 pb-2 px-3">
                        <div className="col-md-3">
                          <label className="form-label labelSize mb-0">City</label>
                          <div className="blood-type input-style p-1 form-control-seller">
                            {/* <div className="d-flex">
                              <div className="w-100">
                                <input
                                  type="search"
                                  value={searchTermtwo}
                                  onChange={handleSearchChangecity}
                                  placeholder="Search city here...."
                                  className="w-100 search-input"
                                  onClick={() => setHidecity(0)}
                                  autoComplete="off"
                                />
                              </div>
                              <div>
                                <span>
                                  <SearchIcon className="search-icon-fs" />
                                </span>
                              </div>
                            </div> */}
                            <select
                              onClick={() => setHidecity(1)}
                              value={selectedcity}
                              className="b-radius selectSize w-100"
                              aria-label="Default select example"
                              name="city" // Non-standard name
                              onChange={(e) => {
                                handleCountryChangecity(e);
                                InputChange(e);
                                handleChange(e);
                              }}
                              autoComplete="off"
                            >
                              {hidecity && <option>Select city</option>}
                              {getcity
                                .filter((city) =>
                                  city.name.toLowerCase().includes(searchTermtwo.toLowerCase())
                                )
                                .map((city) => (
                                  <option key={city.name} value={city.name}>
                                    {city.name}
                                  </option>
                                ))}
                            </select>
                          </div>
                          {errors.city && touched.city ? (
                            <div>
                              <p className="error_text_color">{errors.city}</p>
                            </div>
                          ) : null}
                        </div>
                        <Col className="mt-1" md={3} lg={3} xl={3}>
                          <label className="custm-lble">Unit of Measurement</label>
                          <div className="">
                            <select
                              onChange={(e) => {
                                InputChange(e);
                                handleChange(e);
                              }}
                              aria-label="Default select example"
                              name="unitOfMeasurement" // Non-standard name
                              className="input-style form-control-seller form-select"
                              autoComplete="off"
                            >
                              <option disabled selected>
                                Select Unit
                              </option>
                              {Measurementunit.map((e) => (
                                <option key={e.name}>{e.name}</option>
                              ))}
                            </select>
                          </div>
                          {errors.unitOfMeasurement && touched.unitOfMeasurement ? (
                            <div>
                              <p className="error_text_color">{errors.unitOfMeasurement}</p>
                            </div>
                          ) : null}
                        </Col>
                        <Col md={3} lg={3} xl={3} className="mt-1">
                          <label className="custm-lble">Currency</label>
                          <div className="">
                            <select
                              onChange={(e) => {
                                InputChange(e);
                                handleChange(e);
                              }}
                              aria-label="Default select example"
                              name="currency" // Non-standard name
                              className="input-style form-control-seller form-select"
                              autoComplete="off"
                            >
                              <option disabled selected>
                                Select Currency
                              </option>
                              {currencies.map((e) => (
                                <option key={e.id}>
                                  {e.abbreviation} {e.name}
                                </option>
                              ))}
                            </select>
                          </div>
                          {errors.currency && touched.currency ? (
                            <div>
                              <p className="error_text_color">{errors.currency}</p>
                            </div>
                          ) : null}
                        </Col>
                      </Row>
                      <div className="ps-3 pe-3 pt-4">
                        <label className="custm-lble">Description</label>
                        <textarea
                          onChange={(e) => {
                            InputChange(e);
                            handleChange(e);
                          }}
                          rows={5}
                          name="description" // Non-standard name
                          className="input-style form-control"
                          autoComplete="off"


                        />
                        {errors.description && touched.description ? (
                          <div>
                            <p className="error_text_color">{errors.description}</p>
                          </div>
                        ) : null}
                      </div>
                      <div className="d-flex justify-content-between pt-2">
                        <Col>
                          <Row>
                            <Col lg="9" className="me-auto">
                              <Row>
                                <Col lg={3} className="mt-2 ms-3">
                                  <Card
                                    style={{
                                      width: "6rem",
                                      height: "6rem",
                                      position: "relative", // ✅ to position loader
                                    }}
                                    {...getRootProps()}
                                    className="dropzone"
                                  >
                                    {/* Show loader if uploading */}
                                    {isUploading ? (
                                      <div
                                        style={{
                                          position: "absolute",
                                          inset: 0,
                                          background: "rgba(255,255,255,0.7)",
                                          display: "flex",
                                          justifyContent: "center",
                                          alignItems: "center",
                                          flexDirection: "column",
                                          borderRadius: "0.5rem",
                                        }}
                                      >
                                        <div
                                          className="spinner-border text-primary"
                                          style={{ width: "1.5rem", height: "1.5rem" }}
                                          role="status"
                                        ></div>
                                        <small className="mt-1">{uploadProgress}%</small>
                                      </div>
                                    ) : (
                                      <>
                                        <Card.Img className="imet-fit" src={images.AddImage} />
                                        <Card.Body>
                                          <input
                                            type="file"
                                            id="file"
                                            style={{ display: "none" }}
                                            {...getInputProps()}
                                            multiple
                                            autoComplete="off"
                                          />
                                        </Card.Body>
                                      </>
                                    )}
                                  </Card>
                                </Col>

                                {displayimg?.length > 0 && (
                                  <Col lg={7} className="mt-1 d-flex">
                                    {displayimg.map((image, index) => (
                                      <Card
                                        key={index}
                                        className="me-2 mt-1"
                                        style={{
                                          width: "6rem",
                                          height: "6rem",
                                          border: "2px solid",
                                          position: "relative",
                                        }}
                                      >
                                        <Card.Img
                                          className="imet-fit upload-img mt-0"
                                          src={getAsset(image)}
                                          alt=""
                                          crossOrigin="anonymous"
                                        />
                                        <div
                                          className="close-btnone"
                                          onClick={() => removeImage(index)}
                                        >
                                          <ClearIcon />
                                        </div>
                                      </Card>
                                    ))}
                                  </Col>
                                )}
                              </Row>
                            </Col>
                          </Row>
                        </Col>
                        <div className="d-flex align-items-end pb-3 pe-3">
                          <div className="btns">
                            <button
                              className="btn1"
                              onClick={() => navigate("/SellingSide")}
                            >
                              Cancel
                            </button>
                            <button
                              className="btn2 disable-btn"
                              onClick={(e) => userDatahandler(e)}
                              disabled={!(isValid && dirty)}
                              data-title={
                                !(isValid && dirty)
                                  ? "Please fill out all Fields to enable button!"
                                  : null
                              }
                            >
                              Post
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Form>
                )}
              </Formik>
            </Col>
          </div>
        </Row>
      </Container>
    </>
  );
};

export default PostSingleAdd;